module.exports = __webpack_public_path__ + "img/25.2035d162.png";